import { extendTheme } from '@chakra-ui/react';
import { PRIMARY_FONT, SECONDARY_FONT, FANTASY, CURSIVE } from '@/constants/fonts';
import {
  BG_SECONDARY,
  BG_PRIMARY,
  BG_SECONDARY_DARK,
  BG_SECONDARY_TRANSPARENT,
  BG_ALTERNATIVE,
  TEXT_PRIMARY,
  TEXT_SECONDARY,
  DEFAULT_BUTTON,
  TEXT_PRIMARY_LIGHT,
} from '@/constants/colors';

/**
 * override chackra-ui for personalize purpose
 * see the docs: https://chakra-ui.com/guides/using-fonts
 */
const theme = {
  fonts: {
    heading: PRIMARY_FONT,
    body: SECONDARY_FONT,
    fantasy: FANTASY,
    serif: `'Tinos', serif;`,
    cursive: CURSIVE,
    jost: `'Jost', sans-serif;`,
  },
  colors: {
    bgPrimary: BG_PRIMARY,
    bgSecondary: BG_SECONDARY,
    bgAlternative: BG_ALTERNATIVE,
    btnColor: DEFAULT_BUTTON,
    mainColor: BG_SECONDARY,
    mainColorText: TEXT_PRIMARY,
    secondaryColorText: TEXT_SECONDARY,
    mainColorTextLight: TEXT_PRIMARY_LIGHT,
    transparent: 'transparent',
    theme: {
      bgPrimaryText: TEXT_PRIMARY,
      bgPrimary: BG_PRIMARY,
      bgSecondary: BG_SECONDARY,
      bgSecondaryDark: BG_SECONDARY_DARK,
      bgSecondaryTransparent: BG_SECONDARY_TRANSPARENT,
    },
    button: {
      secondary: {
        500: BG_SECONDARY,
      },
      secondaryDark: {
        500: BG_SECONDARY_DARK,
      },
    },
  },
  shadows: {
    outline: BG_SECONDARY_DARK,
  },
};

export default extendTheme(theme);
